module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showfoot),
      expression: "showfoot"
    }],
    staticClass: "footer-box"
  }, [_c('div', {
    staticClass: "footer-top"
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "footer-fun",
    on: {
      "click": function($event) {
        return _vm.toUrl('/dispute')
      }
    }
  }, [_vm._v("纠纷处理")]), _vm._v(" "), _c('span', {
    staticClass: "footer-fun",
    on: {
      "click": function($event) {
        return _vm.toUrl('/feedback')
      }
    }
  }, [_vm._v("意见处理")]), _vm._v(" "), _c('span', {
    staticClass: "footer-fun",
    on: {
      "click": function($event) {
        return _vm.MEIQIA()
      }
    }
  }, [_vm._v("联系我们")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "footer-fun"
  }, [_c('a', {
    attrs: {
      "href": "http://m.yourhr.com.cn/privacy_policy.html",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("用户协议")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "footer-fun"
  }, [_c('a', {
    attrs: {
      "href": "https://baike.baidu.com/item/%E4%B8%AD%E5%AE%9C%E6%95%99%E8%82%B2/3025781?fr=aladdin",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("关于我们")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "copy-right"
  }, [_vm._v("广州格兰堂信息科技有限公司版权所有   "), _c('a', {
    attrs: {
      "href": "http://beian.miit.gov.cn",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("备案号© 粤ICP备12001590号")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5b216342!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 912
// module chunks = 42